<style>
  main {
    /*background-color: #ddd;*/
    display: flex;
    flex-flow: column;
    /*flex: 1 1 auto;*/
    height: 100%;
    width: 100%;
  }
  .map {
    flex: 1 1 auto;
    /*cursor: pointer;*/
  }
  .settings {
    flex: 0 0 auto;
    display: flex;
    flex-flow: column;
    z-index: 1000;
    position: absolute;
    align-self: flex-end;
    width: 16em;
  }
  .layers {
    flex: 0 0 auto;
    display: flex;
    flex-flow: column;
    align-self: flex-end;
    background-color: #ffeb;
    border-radius: 0.2em;
    margin: 0.4em;
    width: 100%;
  }
  .date {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    align-self: flex-end;
    background-color: #ffeb;
    border-radius: 0.2em;
    margin: 0 0.4em 0.4em 0.4em; /* top | right | bottom | left */
    width: 100%;
  }
  .filler {
    flex: 1 1 auto;
  }
  .layer {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    margin: 0.2em 0.6em 0.4em 0.6em; /* top | right | bottom | left */
    align-self: left;
  }
  .legend {
    margin: 0; /* top | right | bottom | left */
    width: 0.8em;
    height: 0.8em;
    align-self: center;
    margin: 0 0.4em 0 0.4em; /* top | right | bottom | left */
  }
  .caption {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    cursor: pointer;
  }
  .date-select {
    font-size: 1em;
    height: 1.6em;
    padding: 0.2em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
  }
  .go {
    font-size: 1em;
    height: 1.6em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
    padding: 0 0.4em 0 0.4em; /* top | right | bottom | left */
  }
  p {
    font-size: 1em;
    margin: 0.2em 0.4em 0.2em 0.2em; /* top | right | bottom | left */
  }
  .red {
    background-color: #f009;
  }
  label {
    /*text-shadow: -1px -1px 0 #fff8, 1px -1px 0 #fff8, -1px 1px 0 #fff8, 1px 1px 0 #fff8;*/
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    /*margin-top: 0.5em;
    /*margin-bottom: 0.5em;*/
    margin: 0 0 0 0.4em; /* top | right | bottom | left */
    padding: 0.2em 0 0 0; /* top | right | bottom | left */
    /*align-self: center;*/
  }
  .checkbox {
    box-shadow: none;
    min-width: 0em;
    cursor: pointer;
    padding: 0;
    margin: 0;
    align-self: center;
  }
/*  @media screen and (max-width: 800px) {
    .layers {
      margin-top: 3em;
    }
  }*/
</style>

<script>
  import { onMount } from 'svelte';
  import maplibregl from 'maplibre-gl/dist/maplibre-gl.js';
  import 'maplibre-gl/dist/maplibre-gl.css';
  
  function get_dates() {
    let now = new Date();
    let today_str = now.toISOString().slice(0, 10);
    let dates = [];
    let add_date;
    let add_date_str = '2020-08-08'; //start date
    while (add_date_str <= today_str) {
      dates.push(add_date_str);
      add_date = new Date(new Date(`${add_date_str} 12:00`).getTime() + 24 * 3600 * 1000)
      add_date_str = add_date.toISOString().slice(0, 10);
    }
    dates.sort();
    return dates;
  }
  
  function go_prev() {
    let go_index = dates.indexOf(date_selected) - 1;
    if (go_index >= 0) {
      date_selected = dates[go_index];
      update_map();
    }
  }
  
  function go_next() {
    let go_index = dates.indexOf(date_selected) + 1;
    if (go_index < dates.length) {
      date_selected = dates[go_index];
      update_map();
    }
  }
  
  function update_map(event, first_run) {
    var layers = map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    var firstSymbolId;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].type === 'symbol') {
        firstSymbolId = layers[i].id;
        break;
      }
    }
    if (first_run) {
      map.addSource('sat-basemap-xyz', {
        'type': 'raster',
        'tiles': [
          'https://wms.forestradar.com/tiles-v1/dmo-9EDp-Q7Nutoz_Mn4QOtv_A/s2-rgb/{z}/{x}/{y}.png'
        ],
        'tileSize': 256,
        'attribution': '<a href="https://www.baltsat.lv/">Baltic Satellite Service</a>, <a href="https://www.esa.int/">ESA</a>'
        });
      map.addSource('sat-basemap-wms', {
        'type': 'raster',
        'tiles': [
          'https://wms.forestradar.com/wms-v1/dmo-9EDp-Q7Nutoz_Mn4QOtv_A/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&layers=s2_metadata&service=WMS&styles='
        ],
        'tileSize': 512,
        'attribution': '<a href="https://www.baltsat.lv/">Baltic Satellite Service</a>, <a href="https://www.esa.int/">ESA</a>'
      });
    }
    let prev_layer = null;
    if (has_sat_fire) {
      map.removeLayer('sat-fire-layer-poly');
      map.removeLayer('sat-fire-layer-line');
      map.removeSource('sat-fire-source');
      has_sat_fire = false;
    }
    if (show_sat_fire) {
      map.addSource(
        'sat-fire-source',
        {
          'type': 'vector',
          'tiles': [
            `https://api2.forestradar.com/layers/fire/mvt/${date_selected}/{z}/{x}/{y}.pbf`
          ],
          'maxzoom': 10,
        }
      );
      map.addLayer(
        {
          'id': 'sat-fire-layer-line',
          'type': 'line',
          'source': 'sat-fire-source',
          'source-layer': 'data',
          'layout': {},
          'paint': {
            'line-color': '#f00',
            'line-width': 2.5,
            'line-opacity': 0.5,
          },
        },
        prev_layer
      );
      map.addLayer(
        {
          'id': 'sat-fire-layer-poly',
          'type': 'fill',
          'source': 'sat-fire-source',
          'source-layer': 'data',
          'layout': {},
          'paint': {
            'fill-color': '#f00',
            'fill-opacity': 0.5,
          },
        },
        'sat-fire-layer-line'
      );
      prev_layer = 'sat-fire-layer-poly';
      has_sat_fire = true;
    }
    
    if (has_effis) {
      map.removeLayer('effis-layer');
      map.removeSource('effis-source');
      has_effis = false;
    }
    if (show_effis) {
      map.addSource('effis-source', {
        'type': 'raster',
        'tiles': [
          `https://fire.forestradar.com/layers/fire-danger?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&service=WMS&styles=&layers=ecmwf007.fwi&time=${date_selected}`
        ],
        'tileSize': 512,
        'attribution': '<a href="https://europa.eu/european-union/index_en">European Union</a>, <a href="https://effis.jrc.ec.europa.eu/">EFFIS</a>'
      });
      map.addLayer(
        {
          'id': 'effis-layer',
          'type': 'raster',
          'source': 'effis-source',
          'paint': {},
        },
        prev_layer
      );
      prev_layer = 'effis-layer';
      has_effis = true;
    }
    
    if (has_sat_basemap) {
      map.removeLayer('sat-basemap-metadata');
      map.removeLayer('sat-basemap-mosaic');
      has_sat_basemap = false;
    }
    if (show_sat_basemap) {
      map.addLayer(
        {
          'id': 'sat-basemap-metadata',
          'type': 'raster',
          'source': 'sat-basemap-wms',
          'paint': {},
        },
        prev_layer
      );
      map.addLayer(
        {
          'id': 'sat-basemap-mosaic',
          'type': 'raster',
          'source': 'sat-basemap-xyz',
          'paint': {},
        },
        'sat-basemap-metadata'
      );
      prev_layer = 'sat-basemap-mosaic';
      has_sat_basemap = true;
    }
  }
  
  function toggle_layers_open() {
    if (layers_open) {
      layers_open = false;
    } else {
      layers_open = true;
    };
  }
  
  let dates = get_dates();
  let date_selected = dates[dates.length - 1];
  let map;
  
  let has_effis = false;
  let has_sat_basemap = false;
  let has_sat_fire = false;
  
  let show_effis = true;
  let show_sat_basemap = false;
  let show_sat_fire = true;
  
  let layers_open = true;
  
  onMount(() => {
    map = new maplibregl.Map({
      container: 'map',
      style: 'https://api.maptiler.com/maps/streets/style.json?key=ZXgVBaZX5zOt2tnuxT2f',
      zoom: 3,
      center: [17, 55],
      hash: true,
      pitchWithRotate: false,
    });
    map.on('load', function () {
      update_map({}, true);
    });
  });
</script>

<main>
  <div class='settings'>
    <div class='layers'>
      <div class='caption' on:click={toggle_layers_open}>
        <p>Map layers</p>
        <div class='filler'></div>
        {#if layers_open}
          <p>↑</p>
        {:else}
          <p>↓</p>
        {/if}
      </div>
      {#if layers_open}
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='sat-fire' bind:checked={show_sat_fire} on:change={update_map}>
          <label for='sat-fire' class='layer-text'>Suspected forest fires</label>
          <div class='legend red'></div>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='effis' bind:checked={show_effis} on:change={update_map}>
          <label for='effis' class='layer-text'>EFFIS Fire Weather Index</label>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='sat-basemap' bind:checked={show_sat_basemap} on:change={update_map}>
          <label for='sat-basemap' class='layer-text'>Satellite basemap (latest)</label>
        </div>
      {/if}
    </div>
    <div class='date'>
      <p>Date</p>
      <div class='filler'></div>
      <button class='go' on:click={go_prev}>←</button>
      <input type="date" class="date-select" on:change={update_map} min={dates[0]} max={dates[dates.length-1]} required bind:value={date_selected}>
      <button class='go' on:click={go_next}>→</button>
    </div>
  </div>
  <div class='map' id='map'></div>
</main>
